import React, { useState, useEffect } from 'react';
import styles from "../components/loveVigovia.module.css";
import userImg from "../assets/Rectangle 5353.png";
import doubleCodes from "../assets/Frame.png";
import FiveStars from "../assets/Frame 1618873409.png";
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';

const defaultCardData = [
    { id: 1, iconUrl: doubleCodes, description: "We have been operating for over a decade, providing top-notch services to our clients and building a strong track record in the industry. Our commitment to excellence has made us a leader in the field.", userImage: userImg, userName: 'Albert Flores', userLocation: 'Delhi' },
    { id: 2, iconUrl: doubleCodes, description: "Our team has a deep understanding of our field, making us a trusted to achieve their goals. We provide ensure each client receives the support they need.", userImage: userImg, userName: 'Jane Doe', userLocation: 'Mumbai' },
    { id: 3, iconUrl: doubleCodes, description: "Through dedication and expertise, we have established ourselves as a go-to provider, consistently delivering high-quality services tailored to our clients' unique needs.", userImage: userImg, userName: 'John Smith', userLocation: 'Bangalore' },
    { id: 4, iconUrl: doubleCodes, description: "We have been operating for over a decade, providing top-notch services to our clients and building a strong track record in the industry. Our commitment to excellence has made us a leader in the field.", userImage: userImg, userName: 'Emily Davis', userLocation: 'Chennai' },
    { id: 5, iconUrl: doubleCodes, description: "Our team has a deep understanding of our field, making us a trusted to achieve their goals. We provide ensure each client receives the support they need.", userImage: userImg, userName: 'Michael Brown', userLocation: 'Hyderabad' },
];

const LoveVigovia = () => {
    const [cards, setCards] = useState([]);
    const [currentSetIndex, setCurrentSetIndex] = useState(0);
    const [expandedCards, setExpandedCards] = useState({});

    useEffect(() => {
        setTimeout(() => {
            setCards(defaultCardData);
        }, 1000);
    }, []);

    const updateCardSet = (direction) => {
        setCurrentSetIndex((prevIndex) => direction === 'left' ? (prevIndex === 0 ? cards.length - 1 : prevIndex - 1) : (prevIndex === cards.length - 1 ? 0 : prevIndex + 1));
    };

    const handleToggleExpand = (id) => {
        setExpandedCards((prevState) => ({ ...prevState, [id]: !prevState[id] }));
    };

    const currentSet = cards.length > 0 ? [
        cards[currentSetIndex],
        cards[(currentSetIndex + 1) % cards.length],
        cards[(currentSetIndex + 2) % cards.length]
    ] : [];

    return (
        <>
            <div className="container mb-5 mt-5">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="text-start">
                        <h3 style={{ color: "#321E5D", fontWeight: "800" }}>
                            They Love <span style={{ color: "#680099" }}>Vigovia</span>
                        </h3>
                        <p style={{  fontSize: "14px", fontWeight: 500 }}>What Our Clients Are Saying About Us?</p>
                    </div>
                    <div className="d-flex gap-2">
                        <div className="rounded-circle d-flex justify-content-center align-items-center bg-white" 
                            style={{ width: '40px', height: '40px', cursor: 'pointer', transition: 'transform 0.2s' }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            onClick={() => updateCardSet("left")}>
                            <MdArrowBackIos size={24} />
                        </div>
                        <div className="rounded-circle d-flex justify-content-center align-items-center bg-white" 
                            style={{ width: '40px', height: '40px', cursor: 'pointer', transition: 'transform 0.2s' }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            onClick={() => updateCardSet('right')}>
                            <MdArrowForwardIos size={24} />
                        </div>
                    </div>
                </div>
                <div className={`d-flex flex-row justify-content-between gap-4 align-items-center mt-5 rounded-5 ${styles.cardContainer}`}>
                    {currentSet.length > 0 ? currentSet.map((cardData) => (
                        <div key={cardData.id} className={`${styles.card} flex-grow-1`} style={{ maxWidth: '340px' }}>
                            <div className="p-2">
                                <img src={cardData.iconUrl} alt="icon" className={styles.cardImage} />
                            </div>
                            <div>
                                <p className={`${styles.cardDescription}`}>
                                    {expandedCards[cardData.id] ? cardData.description : `${cardData.description.substring(0, 70)}... `}
                                    <span onClick={() => handleToggleExpand(cardData.id)} style={{ color: "lightblue", cursor: "pointer" }}>
                                        {expandedCards[cardData.id] ? " Show Less" : " Read More"}
                                    </span>
                                </p>
                            </div>
                            <div className="d-flex flex-row gap-3">
                                <div>
                                    <img src={userImg} alt="user" className={styles.userImage} />
                                </div>
                                <div>
                                    <span className="text-white">{cardData.userName}</span>
                                    <p className='text-white'>{cardData.userLocation}</p>
                                    <div><img src={FiveStars} alt='a' className='mt-0' width={80} /></div>
                                </div>
                            </div>
                        </div>
                    )) : <p>Loading testimonials...</p>}
                </div>
            </div>
        </>
    );
};

export default LoveVigovia;